<template>
  <div class="table-wrapper">
    <v-data-table
      :loading="isLoading"
      fixed-header
      :headers="headers"
      :items="programs"
      class="mirror-table"
      :class="reorderPermission ? 'table-reorder' : 'table-fixed'"
      disable-pagination
      disable-sort
      hide-default-footer
      :mobile-breakpoint="0"
      loading-text="Carregando... Por favor, aguarde"
      @click:row="handleClickDate"
    >
      <template v-slot:[`item.processing_date`]="{ value }">
        {{ formatDate(value) }}
      </template>
      <template v-slot:[`body.append`]>
        <tr>
          <td />
          <td>
            <div class="mirror-table-footer">
              <v-btn
                v-if="canLoadMore"
                :loading="isLoading"
                text
                @click="$emit('load-more')"
              >
                Carregar mais
              </v-btn>
            </div>
          </td>
          <td />
        </tr>
      </template>
    </v-data-table>
  </div>
</template>

<script>
import { isoDateFormat, dateFormat } from '../../utils/date';
import { mapState } from 'vuex';
export default {
  name: 'HistoricMirrorTable',
  data() {
    return {
      expanded: [],
      showDialog: false,
      selectedItem: {},
    };
  },
  computed: {
    ...mapState({
      canLoadSystemHistoricMirror: state =>
        state.mirror.canLoadSystemHistoricMirror,
    }),
    canLoadMore() {
      const mayHaveMoreProgramsToLoad = this.programs.length >= 10;
      return this.canLoadSystemHistoricMirror && mayHaveMoreProgramsToLoad;
    },
  },
  props: {
    programs: Array,
    headers: Array,
    isLoading: {
      type: Boolean,
      default: true,
    },
    reorderPermission: {
      type: Boolean,
      default: true,
    },
    filter: {
      type: Object,
      default: () => ({
        fromDate: '',
        toDate: '',
      }),
    },
  },
  methods: {
    handleClickDate(item) {
      const formattedDate = isoDateFormat(new Date(item.processing_date));
      this.$store.dispatch('mirror/setSelectNameHistoricMirror', {
        program_name: item.name,
      });
      this.$router.push(
        `/storage/mirror/${item.place}/${item.short_name}?date=${formattedDate}`,
      );
    },
    formatDate(date) {
      return dateFormat(new Date(date));
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/assets/scss/theme-v2.scss';
@import '@/assets/scss/inputs.scss';
.mouse-click {
  cursor: pointer;
}

.table-wrapper {
  padding: 0 16px;

  .mirror-table-skeleton {
    margin: 80px 0 0 0;
  }

  .mirror-table-footer {
    display: flex;
    justify-content: center;
    padding: 10px;
    padding-bottom: 20px;
  }

  ::v-deep .v-data-table {
    &.mirror-table {
      ::-webkit-scrollbar-track {
        background-color: rgba($color-black, 0.02);
      }

      ::-webkit-scrollbar {
        scroll-margin: 0 16px;
        width: 8px;
        height: 8px;
        background-color: rgba($color-black, 0.02);
      }

      ::-webkit-scrollbar-thumb {
        background-color: rgba($color-black, 0.24);
      }

      .v-data-table__wrapper {
        height: calc(100vh - 248px);
        table {
          // HEAD
          thead {
            tr {
              th {
                font-size: 0.8em;
                color: $color-black-80;
                letter-spacing: 0.08em;
                box-shadow: inset 0 -2px 0 rgb(0 0 0 / 8%);
              }
            }
          }

          // BODY
          tbody {
            tr {
              background-color: $color-white;
              will-change: background-color;
              transition: background-color 0.4s ease-in-out;
              cursor: pointer;

              &:hover {
                background-color: rgba($color-primary, 0.04);
                will-change: background-color;
                transition: background-color 0.4s ease-in-out;

                td {
                  color: $color-primary;
                  will-change: color;
                  transition: color 0.4s ease-in-out;
                }
              }

              td {
                color: $color-black-80;
                font-size: 0.88em;
                border-bottom: solid 1px $color-black-08;
                will-change: color;
                transition: color 0.4s ease-in-out;
              }
            }

            .draggable-ghost {
              opacity: 0.4;
              background-color: rgba($color-primary, 0.5);
            }
          }
        }
      }
    }
  }
}
</style>
